import { useEffect } from 'react';

import { useEvent } from './useEvent';

export function useScrollPageToTop(selector = '#formSections') {
  const scrollToTop = useEvent(() => {
    const block = document.querySelector(selector);
    if (block) block.scrollTo(0, 0);
  });

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);

  return { scrollToTop };
}
